import { IAprovacaoFinalMapaConcretagemUseCase } from "../../../presentation/useCases/update/aprovacao_final_mapa_concretagem_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * AprovacaoFinalMapaConcretagemUseCase
 */

export class AprovacaoFinalMapaConcretagemUseCase implements IAprovacaoFinalMapaConcretagemUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async executar(
    idFuncionario: number,
    dataAprovacao: Date,
    idsMapasConcretagem: number[],
  ): Promise<void> {
    await Promise.all(idsMapasConcretagem.map(async idMapaConcretagem => {
      await this.repository.aprovacaoFinalMapaConcretagem(idMapaConcretagem, idFuncionario, dataAprovacao);
    }));
  }
}
